import { render, staticRenderFns } from "./SharePopup.vue?vue&type=template&id=12901c88&"
import script from "./SharePopup.vue?vue&type=script&lang=js&"
export * from "./SharePopup.vue?vue&type=script&lang=js&"
import style0 from "./SharePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports